import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import prev from "./Preview.module.css";

import ProfileDetailsPreview from "./previewmain";
import { API_URL } from "../../../../api";
import { useCookies } from "../../../../hooks/useCookies";
import Sidebar from "../../../userflow/components/sidebar/sidebar";
import { getProfileSelfieImageUrls } from "../../../../utils/serverUtils";

const Preview = () => {
  const [activeTab, setActiveTab] = useState("preview");
  const [showInfo, setShowInfo] = useState(true);
  const [profile, setProfile] = useState({});
  const [language, setLanguage] = useState([]);
  const [quesAns, setQuesAns] = useState([]);
  const [images, setImages] = useState({
    main: null,
    first: null,
    second: null,
  });

  const { getCookie } = useCookies();
  const token = getCookie("token");

  const fetchData = async (url, onSuccess) => {
    try {
      const response = await fetch(`${API_URL}${url}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) onSuccess(data);
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
    }
  };

  useEffect(() => {
    fetchData("customer/update/profileDetails", setProfile);
    fetchData("customer/update/userlanguage", data =>
      setLanguage(data.selectedLanguages)
    );
    fetchData("customer/update/questions", setQuesAns);
    fetchData("customer/update/media", data => {
      const profileImages = getProfileSelfieImageUrls(data);
      setImages(profileImages);
    });
  }, []);

  return (
    <Sidebar>
      <div
        style={{
          flex: 1,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
        }}
      >
        <div style={{ overflowY: "scroll", scrollbarWidth: "none" }}>
          <div className={prev.previewContainer}>
            <div style={{ marginTop: "10px" }}>
              <ProfileDetailsPreview />
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
};

export default Preview;
